/***
 * Custom Input class can able to handle basic validations based on input type
 * Arguments:
 * @regex : Its an optional. User can pass the custom regex as input attribute.
 * for example : <Input regex={"^[0-9a-zA-Z ]+$"} />
 * @errormsg : Its an optional. User can pass the custom error text as input attribute.
 * for example : <Input errormsg="Invalid input value" />
 * @type : type arguments help to validate different type of input values.
 * 
 * All input attributes can be used directly
 * 
 * Caller can access validation result and error text (in case of invalid text) as below:
 * const element = document.getElementsByName("name")[0]
 * const isvalidtext = $(element).attr("isvalidtext")
 * const invaliderrormsg = $(element).attr("invaliderrormsg")
 * 
 */


import React, { useState } from 'react';
import $ from 'jquery';
import toastr from 'toastr';

function Input(props) {

    const [isValidText, setIsValidText] = useState(true);
    const [invalidErrorMsg, setInvalidErrorMsg] = useState("");

    const inputValidation = (event) => {

        const target = event.target;
        const inputValue = target.value;
        const inputType = $(target).attr("type");
        var inputFieldName = $(target).attr("fieldname");

        if (!inputFieldName) {
            inputFieldName = target.placeholder;
            inputFieldName = inputFieldName ? inputFieldName : 'Input field'
        }

        var regPattern = $(target).attr("regex");
        const errorMsg = $(target).attr("errormsg");
        var isValidText = true;
        var defaultErrorMsg = inputFieldName + ' value is invalid';

        if (regPattern) {
            //In case user has passed regex with attribute regex
            regPattern = new RegExp(regPattern);
            isValidText = regPattern.test(inputValue);
        }
        else {
            regPattern = null
            isValidText = true

            switch (inputType) {
                case "email":
                    isValidText = (inputValue !== null && inputValue !== "") ? validateMultipleEmail(inputValue) : true
                    break;
                case "phone":
                    regPattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

                    break;
                case "text":
                    regPattern = /^[0-9a-zA-Z ]+$/;

                    defaultErrorMsg = 'Only Alphabets, Numbers, Space allowed.';
                    break;
                case "username":
                    regPattern = /^[0-9a-zA-Z.@ ]+$/;

                    defaultErrorMsg = 'Valid characters are A-Z a-z 0-9 . @';
                    break;

                case "decimalNumber":
                    regPattern = /^([-]?(\d+\.?|\.(?=\d))?\d{0,1})$/;

                    break;
                case "wholeDecimalNumber":
                    regPattern = /^([0-9]+)?[.]?([0-9])+$/;

                    defaultErrorMsg = 'Only Numbers & Decimal(.) allowed.';
                    break;
                case "number":
                    regPattern = /^[0-9]+$/;

                    defaultErrorMsg = 'Only Numbers allowed.';
                    break;

                default:
                    break;
            }
            if (regPattern) {
                isValidText = regPattern.test(inputValue);
                if (isValidText) {
                    if (inputFieldName.includes("Temperature")) {
                        isValidText = inputValue >= -39 && inputValue <= 256
                        defaultErrorMsg = isValidText ? '' : "Valid range for " + inputFieldName + " is -39 F to 256 F"
                    }
                    else if (inputFieldName.includes("Humidity")) {
                        isValidText = (inputValue >= 1 && inputValue <= 99) || inputValue.length === 0
                        defaultErrorMsg = isValidText ? '' : "Valid range for " + inputFieldName + " is 1% to 99% or Empty"
                    }
                }
            }
        }

        if (errorMsg) {
            //In case user has passed error with attribute errormsg
            defaultErrorMsg = errorMsg
        }

        defaultErrorMsg = isValidText ? "" : defaultErrorMsg

        return { isValidText: isValidText, message: defaultErrorMsg }

    }

    const validateMultipleEmail = (emailIds) => {

        var regPattern = /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;
        var emailArray = emailIds.split(',');//emailIds.includes(',')?emailIds.split(','):emailIds.split(';')
        for (var i = 0; i < emailArray.length; i++) {
            var email = emailArray[i].trim()
            if (!regPattern.test(email))
                return false
        }

        return true
    }

    const onBlur = (event) => {

        let validationResp = inputValidation(event);

        setIsValidText(validationResp.isValidText);
        setInvalidErrorMsg(validationResp.message);

        if (!validationResp.isValidText) {
            toastr.options = {
                "preventDuplicates": 1,
            };

            const position = toastr.options.positionClass
            toastr.options.positionClass = 'toast-top-center';
            toastr.error(validationResp.message);
            toastr.options.positionClass = position;
        }

        if (props.onBlur) {
            props.onBlur(event)
        }
    }

    const onChange = (event) => {
        inputValidation(event);
        let validationResp = inputValidation(event);
        event.target.isvalidtext = validationResp.isValidText;
        event.target.invaliderrormsg = validationResp.message;

        if (props.onChange) {
            props.onChange(event)
        }
    }

    return (
        <input
            {...props}
            onChange={onChange}
            invaliderrormsg={invalidErrorMsg}
            isvalidtext={String(isValidText)}
            onBlur={onBlur}
            style={{ borderColor: !isValidText ? "#ff0000" : "#efefef" }}
        />
    )
}

export default Input;